function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.53305 7.75C5.14925 8.125 4.66951 8.3125 4.09382 8.3125C3.51812 8.3125 3.02772 8.125 2.6226 7.75C2.23881 7.35417 2.04691 6.88542 2.04691 6.34375C2.04691 5.78125 2.23881 5.30208 2.6226 4.90625C3.02772 4.51042 3.51812 4.3125 4.09382 4.3125C4.66951 4.3125 5.14925 4.51042 5.53305 4.90625C5.93817 5.30208 6.14073 5.78125 6.14073 6.34375C6.14073 6.88542 5.93817 7.35417 5.53305 7.75ZM12.2815 4.3125C13.0277 4.3125 13.6674 4.57292 14.2004 5.09375C14.7335 5.61458 15 6.25 15 7V13H13.6567V11H1.37527V13H0V3H1.37527V9H6.81237V4.3125H12.2815Z",
  fill: "#55586F"
});

function SvgProperties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.e8734016.svg";
export { ForwardRef as ReactComponent };